// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeFooterVisibleHeight } from '../../redux/selectors/mainLayoutSelector/mainLayoutSelector';

import NoteIcon from '../../assets/images/note-icon.svg';
import NoteCloseIcon from '../../assets/images/note-close.svg';
import { S } from './NotepadStyles';

export const clearNote = (): void => {
  localStorage.removeItem('notes');
}

const Notepad = (notepadProps:React.ComponentPropsWithRef<'div'>):JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<string>('');
  const footerVisibleHeight = useSelector(makeFooterVisibleHeight());
  const intl = useIntl();

  useEffect(() => {
    const cache = localStorage.getItem('notes');
    if (cache) {
      setValue(cache);
    }
  }, [])

  const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    localStorage.setItem('notes', e.target.value);
  }, []);

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const placeholderText = intl.formatMessage({ id: 'E014' });

  return (
    <S.NotepadContainer {...notepadProps} style={{ bottom: (footerVisibleHeight + 24) + 'px'}} >
      <S.NotepadButton onClick={handleClick}>
        <S.NotepadIcon src={isOpen ? NoteCloseIcon : NoteIcon} alt="Note Icon" />
      </S.NotepadButton>
      {
        isOpen && (
          <S.NotepadTextBoxContainer>
            <S.NotepadTextBoxTitle><FormattedMessage id="E013" /></S.NotepadTextBoxTitle>
            <S.NotepadTextBox placeholder={placeholderText} value={value} onChange={handleChange}/>
          </S.NotepadTextBoxContainer>
        )
      }
    </S.NotepadContainer>
  );
}

export default Notepad;
